export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SET_USER = "SET_USER";
export const SET_USERS = "SET_USERS";
export const GET_USER = "GET_USER";
export const SET_PROFILE = "SET_PROFILE";